export enum ImpactAssessmentTabsEnum {
    UsageVsEmployees = "usage-vs-employees",
    EmployeesVsDataSensitivity = "employees-vs-data-sensitivity",
    EmployeesVsCyberPosture = "employees-vs-cyber-posture",
    CyberPostureVsDataSensitivity = "cyber-posture-vs-data-sensitivity",
}